{
 "name": "0_plant_flower_2",
 "bin": "0_plant_flower_2.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "0_plant_flower_2", "parent": 1, "t": [0.01877722,-4.073975,9.60872e-16], "q": [-1.174855e-05,-0.4055141,0.006183887,0.9140679], "s": [1,1,1]},
  {"name": "", "parent": 10, "t": [-0.1335136,7.735673,-0.2174869], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Capsule01", "parent": 10, "t": [-0.1335155,0.2237181,-0.217485], "q": [-5.338506e-08,-0.7071067,-0.7071069,-5.338508e-08], "s": [1,1,0.6658086]},
  {"name": "Capsule02", "parent": 10, "t": [-0.1335155,0.2237181,-0.217485], "q": [-5.338506e-08,-0.7071067,-0.7071069,-5.338508e-08], "s": [1,1,0.6658086]}
 ],
 "parts": [
  {"node": 12, "vertexCount": 468, "posOffset": 0, "nrmOffset": 5616, "uvOffset": 11232, "material": "0_plant_flower2", "color": [0.2157,0.6118,0,1], "texture": "0_plant_flower_2.png"},
  {"node": 13, "vertexCount": 468, "posOffset": 14976, "nrmOffset": 20592, "uvOffset": 26208, "material": "0_plant_flower2", "color": [0.2157,0.6118,0,1], "texture": "0_plant_flower_2.png"}
 ],
 "anims": [
  {"name": "die", "duration": 0.8, "fps": 30, "frames": 25, "offset": 29952},
  {"name": "grow", "duration": 3.3, "fps": 30, "frames": 100, "offset": 43952},
  {"name": "idle", "duration": 0.36667, "fps": 30, "frames": 12, "offset": 99952},
  {"name": "pick", "duration": 0.96667, "fps": 30, "frames": 30, "offset": 106672}
 ]
}
